<template>
  <div>
    <div class="box" id="box" ref="box">
      <div class="title-box">
        <div class="title-logo"></div>
        <div class="title-txt">知识图谱数据来源</div>
      </div>

      <div class="list-fir">
        <div class="list-box">
          <div class="title-small-txt">漏洞库</div>
          <div class="list-data">
            <div class="list-data-title">
              <td>数据来源</td>
              <td>漏洞数</td>
              <td>更新时间</td>
              <div class="list-data-title-bor"></div>
              <div class="list-data-title-bor-sed"></div>
            </div>

            <div class="data-list-container">
              <div class="data-list-column" v-for="item in bugList">
                <td class="td-column td-border">{{item.value1}}</td>
                <td class="td-column">{{item.value2}}</td>
                <td class="td-column">{{item.value3}}</td>
              </div>
            </div>
          </div>
        </div>
        <div class="list-box">
          <div class="title-small-right-txt">知识库</div>
          <div class="list-data">
            <div class="list-data-title">
              <td>数据来源</td>
              <td>知识数</td>
              <td>更新时间</td>
              <div class="list-data-title-bor"></div>
              <div class="list-data-title-bor-sed"></div>
            </div>

            <div class="data-list-container">
              <div class="data-list-column" v-for="item in knowledgeList">
                <td class="td-column td-border">{{item.value1}}</td>
                <td class="td-column">{{item.value2}}</td>
                <td class="td-column">{{item.value3}}</td>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="list-sed">
        <div class="list-box">
          <div class="title-small-txt">开源情报</div>
          <div class="list-data">
            <div class="list-data-title">
              <td>数据来源</td>
              <td>漏洞数</td>
              <td>更新时间</td>
              <div class="list-data-title-bor"></div>
              <div class="list-data-title-bor-sed"></div>
            </div>

            <div class="data-list-container">
              <div class="data-list-column" v-for="item in newsList">
                <td class="td-column td-border">{{item.value1}}</td>
                <td class="td-column">{{item.value2}}</td>
                <td class="td-column">{{item.value3}}</td>
              </div>
            </div>
          </div>
        </div>
        <div class="list-box">
          <div class="title-small-right-txt">学术论文</div>
          <div class="list-data">
            <div class="list-data-title">
              <td>数据来源</td>
              <td>知识数</td>
              <td>更新时间</td>
              <div class="list-data-title-bor"></div>
              <div class="list-data-title-bor-sed"></div>
            </div>

            <div class="data-list-container">
              <div class="data-list-column" v-for="item in academicList">
                <td class="td-column td-border">{{item.value1}}</td>
                <td class="td-column">{{item.value2}}</td>
                <td class="td-column">{{item.value3}}</td>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>
<script>

import {getNumOfDifferentSource} from "@/service/dashboard";

export default {

  data() {
    return {
      bugList: [
        {value1: "数据来源", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "数据来源", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "数据来源", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "数据来源", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "数据来源", value2: "漏洞数", value3: "2024-06-30"}
      ],
      knowledgeList: [
        {value1: "数据来源", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "数据来源", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "数据来源", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "数据来源", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "数据来源", value2: "漏洞数", value3: "2024-06-30"}
      ],
      newsList: [
        {value1: "数据来源", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "数据来源", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "数据来源", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "数据来源", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "数据来源", value2: "漏洞数", value3: "2024-06-30"}
      ],
      academicList: [
        {value1: "数据来源", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "数据来源", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "数据来源", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "数据来源", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "数据来源", value2: "漏洞数", value3: "2024-06-30"}
      ]
    };
  },
  mounted() {
    getNumOfDifferentSource().then(result => {
      console.log(result);
    });
  },
  methods: {
    getData(){

    }
  }
};


</script>
<style scoped  lang="less">
.box {
  background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
  width: 720px;
  height: 620px;
  border-radius: 10px;
  position: relative;
}
.title-small-txt {
  color: rgba(241, 237, 255, 1);
  font-family: 'YouSheBiaoTiHei';
  font-size: 24px;
  height: 54px;
  width: 260px;
  line-height: 54px;
  position: absolute;
  left: 20px;
  top: 5px;
  text-shadow: 0 2px 20px rgba(42, 56, 180, 1);
  text-align: left;
  padding-left: 20px;
}
.title-small-right-txt {
  color: rgba(241, 237, 255, 1);
  font-family: 'YouSheBiaoTiHei';
  font-size: 24px;
  height: 54px;
  width: 260px;
  line-height: 54px;
  position: absolute;
  left: 380px;
  top: 5px;
  text-shadow: 0 2px 20px rgba(42, 56, 180, 1);
  text-align: left;
  padding-left: 20px;
}
.title-box {
  .title-logo {
    background-image: url("../../assets/img/ask_logo.png");
    background-repeat: no-repeat;
    background-size: 100%;
    height: 53px;
    width: 59px;
    position: absolute;
    left: 20px;
    top: 15px;
  }
  .title-txt {
    background-image: url("../../assets/img/ask_bg.png");
    background-repeat: no-repeat;
    background-size: 100%;
    color: rgba(241, 237, 255, 1);
    font-family: 'YouSheBiaoTiHei';
    font-size: 24px;
    height: 54px;
    width: 260px;
    line-height: 54px;
    position: absolute;
    left: 79px;
    top: 15px;
    text-shadow: 0 2px 20px rgba(42, 56, 180, 1);
    text-align: left;
    padding-left: 20px;
  }
}
.list-fir {
  display: flex;
  position: relative;
  top: 70px;
}
.list-sed {
  display: flex;
  position: relative;
  top: 70px;
}
.warp {
  position: absolute;
  left: 18px;
  top: 58px;
  height: 335px;
  font-family: AlibabaRegular;
  overflow: hidden;
}

ul li{
  list-style-type: none; /* 去除项目符号 */
  width: 383px;
  height: 48px;
  line-height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:0 7px;
  box-sizing: border-box;
  color: #fff;
}

li:nth-of-type(odd){
  background: url("../../assets/PlatformOverview/textBackground.png") no-repeat;
  background-size: 100%;
}
li .date{
  width: 85px;
}
li .test{
  width: 81px;
  color: rgba(159, 158, 242, 1);
}
li .theatre{
  width: 81px;
  color: rgba(244, 191, 54, 1);
}
li .notice{
  width: 185px;
  height: 48px;
  color: #fff;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  span{
    line-height: 14px;
    font-family: AlibabaRegular;
  }
}
.list-box {
  background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
  border-radius: 10px;
  width: 330px;
  height: 235px;
  margin: 10px auto;
}

.list-data {
  .list-data-title {
    background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
    height: 36px;
    line-height: 36px;
    width: 292px;
    margin: 0 auto;
    position: relative;
    top: 40px;
    font-size: 14px;
    color: white;
    text-align: center;

    border: 1px solid #7678ae;
  }
}

.list-data-title::before,
.list-data-title::after {
  content: '';
  position: absolute;
  width: 6px; /* 正方形边长 */
  height: 4px;
  background-color: #aaadeb; /* 正方形颜色 */
}

/* 左上角和右上角 */
.list-data-title::before {
  top: -1px;
  left: -1px; /* 左上角位置 */
  box-shadow: 287px 0 0 0 #aaadeb; /* 用box-shadow制作右上角 */
}

/* 左下角和右下角 */
.list-data-title::after {
  bottom: -1px;
  left: -1px; /* 左下角位置 */
  box-shadow: 287px 0 0 0 #aaadeb;
}

.list-data-title-bor {
  position: absolute;
  width: 1px;
  height: 30px;
  border-left: 2px solid transparent;
  border-image: linear-gradient(to bottom, rgba(159, 158, 242, 0) 0%, #9F9EF2 50%, rgba(159, 158, 242, 0) 100%) 1;
  top: 3px;
  left: 97px;
}

.list-data-title-bor-sed {
  position: absolute;
  width: 1px;
  height: 30px;
  border-left: 2px solid transparent;
  border-image: linear-gradient(to bottom, rgba(159, 158, 242, 0) 0%, #9F9EF2 50%, rgba(159, 158, 242, 0) 100%) 1;
  top: 3px;
  left: 192px;
}
td {
  width: 97px;
  font-weight: bold;
}
.data-list-container {
  cursor: pointer;
  position: relative;
  height: 140px;
  top: 42px;
  width: 300px;
  margin: 0 0 0 18px;
  overflow-y: auto;
  box-sizing: content-box; /* 让padding不影响内容宽度 */
  scrollbar-width: thin; /* 适用于 Firefox，设置滚动条为细长 */
  scrollbar-color: #757ebe transparent; /* 滚动条颜色和背景 */
  .data-list-column {
    //width: 292px;
    height: 37px;
    .td-column {
      position: relative;
      height: 30px;
      line-height: 30px;
      font-size: 14px;
      color: #FFF;
      font-weight: bold;
      border-bottom: 1px solid #9F9EF2;
    }
    .td-border::before {
      content: '';
      position: absolute;
      width: 4px; /* 正方形边长 */
      height: 4px;
      background-color: #aaadeb; /* 正方形颜色 */
    }
    .td-border::before {
      top: 30px;
      left: -1px; /* 左上角位置 */
    }
    //background-color: #00F0FF;
  }
}

/* 适用于 Webkit 内核（如 Chrome 和 Edge） */
.data-list-container::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
  height: 8px; /* 横向滚动条高度 */
}

.data-list-container::-webkit-scrollbar-thumb {
  background-color: #757ebe; /* 滚动条的颜色 */
  border-radius: 4px; /* 让滚动条块稍微圆角 */
}

.data-list-container::-webkit-scrollbar-track {
  background-color: transparent; /* 滚动条背景透明 */
}

</style>
